import useQuery from 'apollo-hooks/lib/useApolloQuery'
import useMutate from 'apollo-hooks/lib/useMutate'
import useMessage from 'App/hooks/useMessage'
import {inboxQueries} from '../queries'
import gql from 'graphql-tag'

export function useConversation(conversationId) {
  const {conversation} = useQuery({
    query: gql`
      query getConversation($conversationId: ID) {
        conversation(conversationId: $conversationId) {
          _id
          lastActivityAt
          isVehicleTyping
          isActiveConversation
          readByVehicleAt
          closedAt
          priority
          assignedAgent {
            _id
            fullName
            activeForAutoAssignChat
          }
          vehicle {
            _id
            code
            fullName
            completedOrdersCount
            categoryId
            phone
            activeOrders {
              _id
            }
            lastEndedConversations {
              _id
              closedAt
            }
          }
        }
      }
    `,
    variables: {conversationId},
    pollInterval: 1000 * 5
  })

  return conversation
}

export function useAssignConversation(conversationId) {
  const mutate = useMutate()
  const showMessage = useMessage()

  const assignConversation = async assignedAdminId => {
    try {
      await mutate({
        mutation: gql`
          mutation assignConversation($conversationId: ID, $assignedAdminId: ID) {
            assignConversation(conversationId: $conversationId, assignedAdminId: $assignedAdminId)
          }
        `,
        variables: {conversationId, assignedAdminId},
        refetchQueries: inboxQueries
      })
      showMessage('Conversación asignada')
    } catch (error) {
      showMessage(error)
    }
  }

  return {assignConversation}
}
/* Nota importante de como se mantienen actualizados los mensajes en la conversación:

Tuve que corregir un bug aquí y tuve que entender como funciona el código.
El código no es muy claro y tiene side-effects en varios lugares y polling de dato en varios lugares.
Dejo este mensaje para ayudar a quien en futuro tenga que volver a entenderlo.

  1. Cuando se envía un mensaje, se actualiza el campo lastActivityAt de la conversación.
  2. Las conversaciones se actualizan cada 4 segundos en web/src/App/Pages/Inbox/Conversation/index.js o cada 5 en este documento. Así obtenemos "lastActivityAt" con frecuencia.
  2. En el useEffect ubicado en web/src/App/Pages/Inbox/Conversation/Messages/index.js se hace un refetch de los mensajes cada vez que se actualiza el campo lastActivityAt de la conversación
  3. De todas formas añadimos un pollInterval de 30 segundos para que se refresque la conversación cada 30 segundos
  
  Para un futuro refactor sería ideal apuntar a una lógica centralizada sin side-effects.
*/
export function useGetMessages({conversationId}) {
  const {messages, refetch} = useQuery({
    query: gql`
      query activeConversationMessages($conversationId: ID) {
        messages(conversationId: $conversationId) {
          _id
          text
          image {
            _id
            url
          }
          date
          isSystemMessage
          senderName
          sentByAdminId
        }
      }
    `,
    variables: {conversationId},
    pollInterval: 1000 * 30
  })

  return {messages, refetch}
}
